<form [formGroup]="mailForm" #formDir="ngForm" [class]="envClass" class="mail-container">

  <mat-toolbar class="custom-toolbar">
    <span class="toolbar-title">{{title}}</span>
    <span class="fill-empty-space"></span>
    <button mat-icon-button type="button" (click)="sendMail()" [disabled]="mailForm.invalid" class="has-tooltip" data-tooltip="Verstuur mail">
      <mat-icon>send</mat-icon>
    </button>
  </mat-toolbar>

  <div class="mail-body">
    <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Recipients</mat-label>
      <input matInput id="recipients" formControlName="recipients" required>
      <mat-error *ngIf="mailForm.get('recipients')?.errors?.['required']">Recipients are required.</mat-error>
      <mat-error *ngIf="mailForm.get('recipients')?.errors?.['pattern']">Please provide valid email addresses</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Subject</mat-label>
      <input matInput id="subject" formControlName="subject" required>
      <mat-error *ngIf="mailForm.get('subject')?.errors?.['required']">Subject is required.</mat-error>
    </mat-form-field>

    <!-- Tiptap Editor & Toolbar -->
    <div class="document-paper">
      <div class="ck-style-toolbar" *ngIf="editor">
        <!-- Formatting: Bold & Italic -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().toggleBold().run()"
            [class.active]="editor.isActive('bold')" title="Bold">
            <mat-icon>format_bold</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().toggleItalic().run()"
            [class.active]="editor.isActive('italic')" title="Italic">
            <mat-icon>format_italic</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Lists -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().toggleBulletList().run()"
            [class.active]="editor.isActive('bulletList')" title="Bullet List">
            <mat-icon>format_list_bulleted</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().toggleOrderedList().run()"
            [class.active]="editor.isActive('orderedList')" title="Numbered List">
            <mat-icon>format_list_numbered</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Alignment -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().setTextAlign('left').run()"
            [class.active]="editor.isActive({ textAlign: 'left' })" title="Align Left">
            <mat-icon>format_align_left</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().setTextAlign('right').run()"
            [class.active]="editor.isActive({ textAlign: 'right' })" title="Align Right">
            <mat-icon>format_align_right</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Quotes & Code -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().toggleBlockquote().run()"
            [class.active]="editor.isActive('blockquote')" title="Blockquote">
            <mat-icon>format_quote</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().toggleCodeBlock().run()"
            [class.active]="editor.isActive('codeBlock')" title="Code Block">
            <mat-icon>integration_instructions</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Undo & Redo -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().undo().run()" [disabled]="!editor.can().undo()"
            title="Undo">
            <mat-icon>undo</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().redo().run()" [disabled]="!editor.can().redo()"
            title="Redo">
            <mat-icon>redo</mat-icon>
          </button>
        </div>
      </div>

      <div #editorElement class="tiptap-editor-content"></div>
    </div>
  </div>

</form>